import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useTrialAccess() {
  const { profile } = useAuth();
  return useQuery({
    queryKey: ["trial-access", profile?.nursery_id],
    enabled: !!profile?.nursery_id,
    queryFn: async () => {
      const id = profile?.nursery_id;
      if (!id) return null;
      const { data, error } = await supabase.from("nurseries").select("trial_required, trial_started_at, trial_ends_at, plan_status, plan_ends_at, current_period_end, past_due_until").eq("id", id).single();
      if (error) throw error;
      const { data: access, error: accessError } = await supabase.rpc("my_subscription_access");
      if (accessError) throw accessError;
      return { ...data, access };
    },
    staleTime: 0,
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
  });
}